import { defaultSvgProps, SvgProps } from "../type/props";

export const EditIcon = (props?: SvgProps) => {
  const { width, height, fill, stroke, style } = defaultSvgProps(props, {
    width: 16,
    height: 16,
    fill: "none",
    stroke: "currentColor",
    style: {
      flexShrink: 0,
    },
  });

  return (
    <svg
      viewBox="0 0 24 24"
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={style}
    >
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
    </svg>
  );
};
